import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-improvements',
  templateUrl: './improvements.component.html',
})
export class ImprovementsComponent extends ReportShareComponent {}

